// action types
import axios from "axios";
import { combineReducers } from "redux";

import { ToastType } from "../components/ToastManager/constants";
import {
  orderType,
  tablePageSizes,
} from "../components/ui-library/CustomTable/constants";
import { UserStatus } from "../components/library/AccountStatus/AccountStatus.constants";
import { globalAction } from "redux-subspace";
import { getClaims } from "./login";
import { RecoverPasswordType } from "./constants";

const canEditNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canEdit");

const canBlockParticipant = (state) => getClaims(state, "participant.canBlock");
const canBlockNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canBlock");
const canUnlockNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canUnlock");
const canResendInviteNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canResendInvite");
const canResetPasswordNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canResetPassword");

const canCreateStudyAdmin = (state) =>
  getClaims(state, "study.admin.canCreate");
const canAddSite = (state) => getClaims(state, "site.canEdit");

export const LOADING_ADMIN_USERS = "LOADING_ADMIN_USERS";
export const SET_ADMIN_USERS = "SET_ADMIN_USERS";
export const SET_ADMIN_USERS_ERROR = "SET_ADMIN_USERS_ERROR";

export const LOADING_PARTICIPANT_USERS = "LOADING_PARTICIPANT_USERS";
export const SET_PARTICIPANT_USERS = "SET_PARTICIPANT_USERS";
export const SET_PARTICIPANT_USERS_ERROR = "SET_PARTICIPANT_USERS_ERROR";

export const SET_AVAILABLE_STUDIES = "SET_AVAILABLE_STUDIES";
export const SET_AVAILABLE_ROLES = "SET_AVAILABLE_ROLES";
export const SET_AVAILABLE_STUDIES_ERROR = "SET_AVAILABLE_STUDIES_ERROR";
export const SET_AVAILABLE_ROLES_ERROR = "SET_AVAILABLE_ROLES_ERROR";

export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

export const BLOCK_UNBLOCK_USER_SUCCESS = "BLOCK_UNBLOCK_USER_SUCCESS";
export const BLOCK_UNBLOCK_USER_ERROR = "BLOCK_UNBLOCK_USER_ERROR";

export const UNLOCK_USER_SUCCESS = "UNLOCK_USER_SUCCESS";
export const UNLOCK_USER_ERROR = "UNLOCK_USER_ERROR";

export const SET_STATUS = "SET_STATUS";
export const RESET_STATE = "RESET_STATE";

// action creators

export const loadDataError = (e) => (dispatch) => {
  if (e?.response?.data) {
    dispatch({
      type: SET_STATUS,
      payload: {
        status: {
          text: e.response?.data
            ? e.response.data
            : `There was an error while trying to load the data!`,
          response: e,
          type: ToastType.ERROR,
        },
      },
    });
  }
};

export const fetchAdminUsers = (params) => (dispatch, getState) => {
  if (!params) {
    params = getState().profileManagement.usersReducer.params;
  }

  dispatch({ type: LOADING_ADMIN_USERS });

  return axios
    .get(`/api/account/management`, { params })
    .then(({ data }) => {
      return dispatch({
        type: SET_ADMIN_USERS,
        data,
        params,
      });
    })
    .catch((e) => {
      dispatch(loadDataError(e));
      return dispatch({ type: SET_ADMIN_USERS_ERROR, fetchError: e });
    });
};

export const fetchParticipantUsers = (params) => (dispatch, getState) => {
  if (!params) {
    params = getState().profileManagement.participantUsersReducer.params;
  }

  dispatch({
    type: LOADING_PARTICIPANT_USERS,
  });

  return axios
    .get(`/api/account/management/participants`, {
      params,
    })
    .then(({ data }) => {
      return dispatch({
        type: SET_PARTICIPANT_USERS,
        data,
        params,
      });
    })
    .catch((e) => {
      dispatch(loadDataError(e));
      return dispatch({ type: SET_PARTICIPANT_USERS_ERROR, fetchError: e });
    });
};

export const fetchAvailableStudies = () => (dispatch) => {
  return axios
    .get(`/api/study`)
    .then(({ data }) => {
      return dispatch({ type: SET_AVAILABLE_STUDIES, studies: data });
    })
    .catch((e) => {
      dispatch(loadDataError(e));
      return dispatch({ type: SET_AVAILABLE_STUDIES_ERROR, error: e });
    });
};

export const fetchAvailableRoles = () => (dispatch) => {
  return axios
    .get(`/api/account/management/roles`)
    .then(({ data }) => {
      return dispatch(globalAction({ type: SET_AVAILABLE_ROLES, roles: data }));
    })
    .catch((e) => {
      dispatch(loadDataError(e));
      return dispatch(
        globalAction({ type: SET_AVAILABLE_ROLES_ERROR, fetchError: e })
      );
    });
};

export const resetPassword = (username) => (dispatch) => {
  return axios
    .post(`/api/account/recoverpassword`, {
      Email: username,
      RecoverPasswordType: RecoverPasswordType.resetPassword,
    })
    .then(({ data }) => {
      dispatch({ type: RESET_PASSWORD_SUCCESS });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: "Password Reset sent successfully!",
            response: data,
            type: ToastType.SUCCESS,
          },
        },
      });
      return Promise.resolve("Password Reset sent successfully!");
    })
    .catch((e) => {
      dispatch({ type: RESET_PASSWORD_ERROR, error: e });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: "There was an error while trying to reset the user password.",
            response: e,
            type: ToastType.ERROR,
          },
        },
      });
      return Promise.reject(
        "There was an error while trying to reset the user password."
      );
    });
};

export const blockUnblockUser = (username, status) => (dispatch) => {
  return axios
    .post(`/api/account/management/status/block `, {
      UserName: username,
      Blocked: status,
    })
    .then(({ data }) => {
      dispatch({ type: BLOCK_UNBLOCK_USER_SUCCESS });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: `User ${status ? "blocked" : "unblocked"} successfully!`,
            response: data,
            type: ToastType.SUCCESS,
          },
        },
      });
      return Promise.resolve(
        `User ${status ? "blocked" : "unblocked"} successfully!`
      );
    })
    .catch((e) => {
      dispatch({ type: BLOCK_UNBLOCK_USER_ERROR, error: e });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: `There was an error while trying to ${
              status ? "block" : "unblock"
            } the user!`,
            response: e,
            type: ToastType.ERROR,
          },
        },
      });
      return Promise.reject(
        e.response?.data
          ? e.response.data
          : `There was an error while trying to ${
              status ? "block" : "unblock"
            } the user!`
      );
    });
};

export const unlockUser = (username) => (dispatch) => {
  return axios
    .post(
      `/api/account/management/status/unlock?userName=${encodeURIComponent(
        username
      )}`
    )
    .then(({ data }) => {
      dispatch({ type: UNLOCK_USER_SUCCESS });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: `User unlocked successfully!`,
            response: data,
            type: ToastType.SUCCESS,
          },
        },
      });
      return Promise.resolve("User unlocked successfully!");
    })
    .catch((e) => {
      dispatch({ type: UNLOCK_USER_ERROR, error: e });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: `There was an error while trying to unlock the user!`,
            response: e,
            type: ToastType.ERROR,
          },
        },
      });
      return Promise.reject(
        e.response?.data
          ? e.response.data
          : "There was an error while trying to unlock the user!"
      );
    });
};

export const resendInvite = (username) => (dispatch) => {
  return axios
    .put(`/api/account/management/resendinvite`, {
      email: username,
    })
    .then(({ data }) => {
      dispatch({ type: UNLOCK_USER_SUCCESS });
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: `Invite resent successfully!`,
            response: data,
            type: ToastType.SUCCESS,
          },
        },
      });
      return Promise.resolve("Invite resent successfully!");
    })
    .catch((e) => {
      dispatch({
        type: SET_STATUS,
        payload: {
          status: {
            text: `There was an error while trying to resend the invite!`,
            response: e,
            type: ToastType.ERROR,
          },
        },
      });
      return Promise.reject(
        "There was an error while trying to resend the invite!"
      );
    });
};

export const resetStatus = () => (dispatch) => {
  return dispatch({
    type: SET_STATUS,
    payload: {
      status: null,
    },
  });
};

export const resetState = () => (dispatch) => {
  return dispatch({
    type: RESET_STATE,
  });
};

// selectors
export const getModuleData = (state) => state.profileManagement;

export const getAdminUsers = (state) => getModuleData(state).usersReducer.users;
export const getAdminUsersError = (state) => getModuleData(state).fetchError;

export const getParticipantUsers = (state) =>
  getModuleData(state).participantUsersReducer.participantUsers;
export const getParticipantUsersError = (state) =>
  getModuleData(state).fetchError;

export const getRoles = (state) => getModuleData(state).roles;
export const getStudies = (state) => getModuleData(state).studies;

export const getStatus = (state) => getModuleData(state).status;

export const getTotalItems = (state) =>
  getModuleData(state).usersReducer.totalitems;
export const getSearchedParams = (state) =>
  getModuleData(state).usersReducer.params;
export const getLoadingAdminUsers = (state) =>
  getModuleData(state).usersReducer.loading;

export const getParticipantTotalItems = (state) =>
  getModuleData(state).participantUsersReducer.totalitems;
export const getParticipantSearchedParams = (state) =>
  getModuleData(state).participantUsersReducer.params;
export const getLoadingParticipantUsers = (state) =>
  getModuleData(state).participantUsersReducer.loading;

// mappings
export const mapStateToPropsManagement = (state) => ({
  users: getAdminUsers(state),
  usersError: !!getAdminUsersError(state),

  roles: getRoles(state),
  studies: getStudies(state),

  status: getStatus(state),
  totalitems: getTotalItems(state),
  searchedParams: getSearchedParams(state),
  loading: getLoadingAdminUsers(state),
  canEditNonParticipant: canEditNonParticipant(state),
  canBlockParticipant: canBlockParticipant(state),
  canBlockNonParticipant: canBlockNonParticipant(state),
  canUnlockNonParticipant: canUnlockNonParticipant(state),
  canResendInviteNonParticipant: canResendInviteNonParticipant(state),
  canResetPasswordNonParticipant: canResetPasswordNonParticipant(state),
  canCreateStudyAdmin: canCreateStudyAdmin(state),
  canAddSite: canAddSite(state),
});

export const mapToStateToPropsParticipant = (state) => ({
  participantUsers: getParticipantUsers(state),
  totalitems: getParticipantTotalItems(state),
  searchedParams: getParticipantSearchedParams(state),
  loading: getLoadingParticipantUsers(state),
  status: getStatus(state),
});

// reducers

const resetPasswordInitialState = {
  updateError: "",
};
const resetPasswordReducer = (state = resetPasswordInitialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        updateError: action.error,
      };
    default:
      return state;
  }
};

const usersInitialState = {
  users: [],
  fetchError: null,
  updateError: null,
  totalitems: null,
  loading: false,
  params: {
    page: 0,
    limit: tablePageSizes[0],
    filter: UserStatus.ALL.id,
    search: "",
    orderBy: "created",
    order: orderType.DESC,
  },
};
const usersReducer = (state = usersInitialState, action) => {
  switch (action.type) {
    case LOADING_ADMIN_USERS:
      return {
        ...state,
        loading: true,
      };
    case SET_ADMIN_USERS:
      return {
        ...state,
        users: action.data.data,
        fetchError: null,
        updateError: null,
        totalitems: action.data.records,
        params: action.params,
        loading: false,
      };
    case SET_ADMIN_USERS_ERROR:
      return {
        ...state,
        updateError: action.error,
        loading: false,
      };
    case RESET_STATE:
      return usersInitialState;
    default:
      return state;
  }
};

const participantUsersInitialState = {
  participantUsers: [],
  fetchError: null,
  updateError: null,
  totalitems: null,
  loading: false,
  params: {
    page: 0,
    limit: tablePageSizes[0],
    filter: UserStatus.ALL.id,
    search: "",
    orderBy: "created",
    order: orderType.DESC,
  },
};
const participantUsersReducer = (
  state = participantUsersInitialState,
  action
) => {
  switch (action.type) {
    case LOADING_PARTICIPANT_USERS:
      return {
        ...state,
        loading: true,
      };
    case SET_PARTICIPANT_USERS:
      return {
        ...state,
        participantUsers: action.data.data,
        fetchError: null,
        updateError: null,
        totalitems: action.data.records,
        params: action.params,
        loading: false,
      };
    case SET_PARTICIPANT_USERS_ERROR:
      return {
        ...state,
        updateError: action.error,
        loading: false,
      };
    case RESET_STATE:
      return participantUsersInitialState;
    default:
      return state;
  }
};

const rolesInitialState = {
  roles: [],
  fetchError: null,
};
const rolesReducer = (state = rolesInitialState, action) => {
  switch (action.type) {
    case SET_AVAILABLE_ROLES:
      return {
        ...state,
        roles: action.roles,
      };
    case SET_AVAILABLE_ROLES_ERROR:
      return {
        ...state,
        fetchError: action.error,
      };
    default:
      return state;
  }
};

const studiesInitialState = {
  studies: [],
  fetchError: null,
};
const studiesReducer = (state = studiesInitialState, action) => {
  switch (action.type) {
    case SET_AVAILABLE_STUDIES:
      return {
        ...state,
        studies: action.studies,
      };
    case SET_AVAILABLE_STUDIES_ERROR:
      return {
        ...state,
        fetchError: action.error,
      };
    default:
      return state;
  }
};

const blockUnblockUserInitialState = {
  updateError: "",
};
const blockUnblockUserReducer = (
  state = blockUnblockUserInitialState,
  action
) => {
  switch (action.type) {
    case BLOCK_UNBLOCK_USER_SUCCESS:
      return {
        ...state,
      };
    case BLOCK_UNBLOCK_USER_ERROR:
      return {
        ...state,
        updateError: action.error,
      };
    default:
      return state;
  }
};

const unlockUserInitialState = {
  updateError: "",
};
const unlockUserReducer = (state = unlockUserInitialState, action) => {
  switch (action.type) {
    case UNLOCK_USER_SUCCESS:
      return {
        ...state,
      };
    case UNLOCK_USER_ERROR:
      return {
        ...state,
        updateError: action.error,
      };
    default:
      return state;
  }
};

const statusInitialState = {
  status: null,
};
const statusReducer = (state = statusInitialState, action) => {
  switch (action.type) {
    case SET_STATUS: {
      const {
        payload: { status },
      } = action;
      return Object.assign({}, state, {
        status: status,
      });
    }
    default: {
      return state;
    }
  }
};

export default combineReducers({
  usersReducer: usersReducer,
  participantUsersReducer: participantUsersReducer,
  roles: rolesReducer,
  studies: studiesReducer,
  resetPassword: resetPasswordReducer,
  blockUnblockUser: blockUnblockUserReducer,
  unlockUser: unlockUserReducer,
  status: statusReducer,
});

export const mapDispatchToPropsManagement = {
  fetchAdminUsers,
  fetchParticipantUsers,
  fetchAvailableStudies,
  fetchAvailableRoles,
  resetPassword,
  blockUnblockUser,
  unlockUser,
  resetStatus,
  resetState,
  resendInvite,
};
